import { ResponsiveImage } from "@made-people/blueprint-responsive-image";
import { SizeGuideTable } from "@made-people/blueprint-size-guide-table";
import { SwipeIndicator } from "./swipe-indicator";
import { useSizeGuide } from "./use-size-guide";

interface TableData {
  thead: Array<{ value: string }>;
  tbody: Array<{
    body: Array<{ value: string }>;
  }>;
}

interface SizeGuideTableWrapperProps {
  tableData: TableData;
  icon?: {
    filename: string;
    alt?: string;
  };
  title?: string;
  heading?: string;
}

export const SizeGuideTableWrapper = ({
  tableData,
  icon,
  title,
  heading,
}: SizeGuideTableWrapperProps) => {
  const sizeGuide = useSizeGuide();
  if (!sizeGuide) return null;

  const gotTitleOrIcon = icon || title;
  return (
    <>
      {gotTitleOrIcon && (
        <div className="flex items-center justify-center flex-col w-full text-body-md lg:text-body-lg gap-4 pt-4 lg:pt-20">
          {icon && (
            <ResponsiveImage
              initial={{
                src: icon.filename,
                alt: icon.alt || `${title} Icon`,
              }}
              displaySize="90px"
              className="block max-w-full w-[140px]"
            />
          )}
          {title && (
            <span
              className={`${icon ? "" : "text-heading-md text-left w-full"}`}
            >
              {title}
            </span>
          )}
        </div>
      )}
      <SwipeIndicator />

      <SizeGuideTable
        metricCharts={[
          {
            content: {
              thead: tableData.thead,
              tbody: tableData.tbody,
            },
          },
        ]}
        imperialCharts={[]}
        heading={heading ? { heading } : undefined}
      />
    </>
  );
};
